
  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".product-slideshow");
    document.querySelector(".arrow.left")?.addEventListener("click", () => {
      wrapper.scrollBy({ left: -wrapper.offsetWidth, behavior: 'smooth' });
    });
    document.querySelector(".arrow.right")?.addEventListener("click", () => {
      wrapper.scrollBy({ left: wrapper.offsetWidth, behavior: 'smooth' });
    });
  });
    $(document).ready(function() {
      $('#insert-image-btn').on('click', function () {
          $('#transaction-image').click();
      });

      $('#transaction-image').on('change', function () {
          const file = this.files[0];
          if (!file) return;

          const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpeg', 'image/webp'];
          const maxSize = 2 * 1024 * 1024; // 2MB

          if (!allowedTypes.includes(file.type)) {
              alert('File harus berupa gambar (JPG/JPEG, PNG, GIF, WEBP).');
              $(this).val('');
              return;
          }

          if (file.size > maxSize) {
              alert('Ukuran gambar maksimal 2MB.');
              $(this).val('');
              return;
          }

          $(".please-insert").html(file.name)
      });

      // AJAX Submit
      $('#image-upload-form').on('submit', function (e) {
          e.preventDefault();

          const fileInput = $('#transaction-image')[0];
          if (!fileInput.files.length) {
              alert('Insert image first.');
              return;
          }

          const formData = new FormData();
          formData.append('transaction_image', fileInput.files[0]);
          formData.append('url_shopify', $("#image-upload-form input[name=url_shopify]").val());
          formData.append('order_number', $("#image-upload-form input[name=order_number]").val());
          formData.append('email', $("#image-upload-form input[name=email]").val());
          formData.append('reasons', $("#image-upload-form [name=reasons]").val());

          $("#image-upload-form button[type=submit]").html("Please wait...").attr("disabled", "disabled")

          setTimeout(() => {
              $("#image-upload-form button[type=submit]").html("Submit").removeAttr("disabled")
          }, 5000);

          $.ajax({
              url: 'https://custom-app.nubukbags.com/archives/insert_confirm_payment',
              type: 'POST',
              data: formData,
              processData: false,
              contentType: false,
              beforeSend: function() {
                  $("#image-upload-form button[type=submit]").html("Please wait...").attr("disabled", true);
              },
              success: function (response) {
                  $("#image-upload-form button[type=submit]").html("Submit").removeAttr("disabled")

                  let result = JSON.parse(response);
                  if(result.status != 200){
                      alert(result.message)
                  }
                  else {
                    // alert("Thank you for submitting.")
                    $(".form-confirm-payment").append(`
                        <p class="return-success">Success, Thank you for submitting. <span class="svg-wrapper"><svg class="icon icon-success" viewBox="0 0 13 13"><path fill="#428445" stroke="#fff" stroke-width=".7" d="M6.5 12.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"></path><path stroke="#fff" d="m5.533 8.664 3.72-3.982M4.106 6.769l2.032 1.857"></path></svg></span></p>    
                    `)
                    setTimeout(function() {
                        location.reload()
                    }, 3000);
                      
                  }
              },
              error: function (xhr, status, error) {
                  console.log(error)
              }
          });
      });
    });
